export const INSTANT_SEARCH_INDEX_NAME = 'development_api::merchant-web.merchant-web';
export const INSTANT_SEARCH_QUERY_SUGGESTIONS = 'development_api::merchant-web.merchant-web_query_suggestions';